// Individual doctor pages content.
// Only doctors listed here have a dedicated /doctors/:slug page.
// Content is deliberately general and factual (no invented facts).

export const DOCTOR_PAGES = {
  baryska: {
    slug: "baryska",
    seoTitle:
      "Бариська Оксана Богданівна — офтальмолог, лікар вищої категорії | Чернівці, Центр «Ваш зір»",
    seoDescription:
      "Бариська Оксана Богданівна — завідувачка діагностичним відділенням Центру мікрохірургії ока «Ваш зір» у Чернівцях. Лікар-офтальмолог вищої категорії, 29 років досвіду. Запис на консультацію та діагностику зору.",
    tagline: "Завідувачка діагностичним відділенням",
    subtitle:
      "Лікар-офтальмолог вищої категорії з 29-річним досвідом у діагностиці захворювань очей",
    intro: [
      "Бариська Оксана Богданівна — лікар-офтальмолог вищої категорії, завідувачка діагностичним відділенням Центру мікрохірургії ока «Ваш зір» у Чернівцях. Понад 29 років працює у сфері офтальмології, спеціалізуючись на комплексній діагностиці захворювань очей у дорослих і підлітків.",
      "Керує роботою діагностичного відділення, у якому пацієнти проходять повний цикл обстежень — від перевірки гостроти зору до інструментальної діагностики стану сітківки, зорового нерва та переднього відрізка ока. Формує індивідуальний план обстеження для кожного пацієнта та узгоджує подальше лікування з профільними хірургами клініки.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Комплексна діагностика зору", desc: "Візометрія, авторефрактометрія, кератометрія — базове обстеження гостроти зору та рефракції." },
        { title: "Дослідження очного дна", desc: "Офтальмоскопія та огляд периферії сітківки для виявлення дистрофій, розривів, ознак діабетичної ретинопатії." },
        { title: "Оптична когерентна томографія (ОКТ)", desc: "Пошарове сканування сітківки та зорового нерва для діагностики макулярної дегенерації, глаукоми, набряків." },
        { title: "Комп'ютерна периметрія", desc: "Дослідження полів зору — ключовий метод діагностики глаукоми та неврологічних порушень." },
        { title: "Тонометрія та пахіметрія", desc: "Вимірювання внутрішньоочного тиску й товщини рогівки — основа діагностики глаукоми." },
        { title: "Біомікроскопія переднього відрізка", desc: "Огляд рогівки, райдужки, кришталика на щілинній лампі — виявлення катаракти й запальних процесів." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 29 років практики в галузі офтальмології",
        "Лікар вищої кваліфікаційної категорії",
        "Керівник діагностичного відділення Центру «Ваш зір»",
        "Робота з обладнанням світового рівня: ОКТ, комп'ютерна периметрія, авторефрактометри останнього покоління",
        "Взаємодія з хірургами клініки для точної передопераційної підготовки пацієнтів",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "Погіршення гостроти зору вдалину або зблизька",
        "Розмите або спотворене зображення, «мушки» перед очима",
        "Дискомфорт, різь, відчуття піску в очах",
        "Планова щорічна перевірка зору",
        "Підготовка до операції з катаракти, глаукоми, лазерної корекції",
        "Контроль зору при цукровому діабеті, гіпертонії, глаукомі",
        "Підбір окулярів та контактних лінз",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Бариської Оксани Богданівни?", a: "Записатися можна за телефонами клініки або через форму запису на сайті." },
      { q: "Скільки триває первинна консультація та діагностика зору?", a: "Від 30 хвилин до півтори години — залежно від того, чи потрібно розширяти зіницю." },
      { q: "Чи потрібна підготовка до візиту до офтальмолога?", a: "Спеціальної підготовки не потрібно. Якщо носите окуляри або контактні лінзи — візьміть їх з собою. За потреби лікар може закапати краплі для розширення зіниці, тому не рекомендуємо приїжджати за кермом." },
      { q: "Куди звернутися після діагностики, якщо потрібне лікування?", a: "У Центрі «Ваш зір» ви проходите повний цикл — від діагностики до лікування у профільних хірургів. Після обстеження Оксана Богданівна направляє до відповідного спеціаліста клініки." },
    ],
  },

  zamiatin: {
    slug: "zamiatin",
    seoTitle: "Замятін Віктор Львович — лікар-терапевт вищої категорії | Чернівці, Центр «Ваш зір»",
    seoDescription:
      "Замятін Віктор Львович — лікар-терапевт вищої кваліфікаційної категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях. 33 роки досвіду. Контроль загального стану пацієнтів при проведенні всіх операцій у клініці.",
    tagline: "Лікар-терапевт вищої категорії",
    subtitle:
      "Лікар-терапевт вищої категорії з 33-річним досвідом. Контроль загального стану пацієнтів під час усіх операцій у Центрі «Ваш зір»",
    intro: [
      "Замятін Віктор Львович — лікар-терапевт вищої кваліфікаційної категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях.",
      "Понад 33 роки практики у веденні загального стану пацієнтів під час усіх операцій у Центрі мікрохірургії ока «Ваш зір». Проводить контроль та корекцію загального стану пацієнтів на всіх етапах — до, під час і після хірургічного втручання.",
    ],
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 33 роки практики в медицині",
        "Лікар вищої кваліфікаційної категорії",
        "Ведення дорослих пацієнтів усіх вікових груп",
        "Робота у складі команди Центру «Ваш зір» у тісній взаємодії з хірургами",
      ],
    },
  },

  karliichuk: {
    slug: "karliichuk",
    seoTitle:
      "Карлійчук Марина Аксентіївна — вітреоретинальний хірург, д.м.н., професор | Чернівці, «Ваш зір»",
    seoDescription:
      "Карлійчук Марина Аксентіївна — завідувачка відділенням вітреоретинальної та лазерної мікрохірургії ока Центру «Ваш зір». Доктор медичних наук, професор, 29 років досвіду. Лікування захворювань сітківки в Чернівцях.",
    tagline: "Завідувачка відділенням вітреоретинальної та лазерної мікрохірургії ока",
    subtitle:
      "Доктор медичних наук, професор, лікар вищої категорії. 29 років досвіду у хірургії сітківки та склистого тіла",
    intro: [
      "Карлійчук Марина Аксентіївна — доктор медичних наук, професор, лікар вищої категорії, завідувачка відділенням вітреоретинальної та лазерної мікрохірургії ока Центру «Ваш зір».",
      "Спеціалізується на діагностиці, лазерному та мікрохірургічному лікуванні захворювань сітківки та склистого тіла. Понад 29 років працює у сфері вітреоретинальної хірургії. Проводить складні операції з відновлення зору при відшаруванні сітківки, діабетичній ретинопатії, макулярній дегенерації та інших патологіях заднього відрізка ока з використанням сучасного мікрохірургічного обладнання.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Лазерна коагуляція сітківки", desc: "Профілактика та лікування дистрофій, розривів, локального відшарування сітківки." },
        { title: "Вітректомія", desc: "Мікрохірургічні втручання на склистому тілі при крововиливах, тяжах, ретинопатії." },
        { title: "Хірургія відшарування сітківки", desc: "Складні операції з повернення сітківки на місце та її фіксацією." },
        { title: "Лікування діабетичної ретинопатії", desc: "Комплексний підхід — від лазерного лікування до вітреоретинальної хірургії." },
        { title: "Лікування макулярної дегенерації (АМД)", desc: "Ведення пацієнтів із сухою та вологою формою макулодистрофії." },
        { title: "Інтравітреальні ін'єкції", desc: "Анти-VEGF терапія при набряках сітківки, АМД, тромбозах вен." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Доктор медичних наук, професор",
        "Лікар вищої кваліфікаційної категорії",
        "Завідувачка відділенням вітреоретинальної та лазерної мікрохірургії",
        "Понад 29 років у діагностиці та лікуванні сітківки",
        "Автор безлічі наукових публікацій у галузі офтальмології",
        "Робота з сучасним хірургічним обладнанням світового рівня",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "«Мушки», спалахи, плаваючі помутніння перед очима",
        "Раптове або поступове зниження зору",
        "«Пляма» або тінь у полі зору",
        "Спотворення прямих ліній, зменшення центрального зору",
        "Діагноз «діабетична ретинопатія», «розрив сітківки», «АМД»",
        "Підозра на відшарування сітківки",
        "Планова перевірка сітківки при цукровому діабеті",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Карлійчук Марини Аксентіївни?", a: "Записатися можна за телефонами клініки або через форму на сайті." },
      { q: "Які операції на сітківці проводить Марина Аксентіївна?", a: "Весь перелік лазерних та мікрохірургічних операцій на сітківці." },
      { q: "Що таке інтравітреальна ін'єкція та коли вона потрібна?", a: "На відміну від старого підходу, коли препарати для лікування сітківки вводились «у вену» і до сітківки доходила лише незначна кількість, тепер в операційній мікродоза препарату вводиться в склисте тіло ока — саме біля сітківки, що дає незмірно більший ефект лікування." },
      { q: "Чи потрібна попередня діагностика перед хірургічним лікуванням?", a: "Так, обов'язкова комплексна діагностика: ОКТ, огляд очного дна з розширенням зіниці." },
    ],
  },

  kirbaba: {
    slug: "kirbaba",
    seoTitle:
      "Кірбаба Ірина Володимирівна — дитячий офтальмолог, лікар вищої категорії | Чернівці, «Ваш зір»",
    seoDescription:
      "Кірбаба Ірина Володимирівна — завідувачка відділенням дитячої офтальмології Центру «Ваш зір» у Чернівцях. 35 років досвіду в лікуванні короткозорості, амбліопії, косоокості у дітей. Запис на консультацію.",
    tagline: "Завідувачка відділенням дитячої офтальмології",
    subtitle:
      "Дитячий лікар-офтальмолог вищої категорії з 35-річним досвідом. Спеціалізація — зір у дітей та підлітків",
    intro: [
      "Кірбаба Ірина Володимирівна — лікар вищої категорії, завідувачка відділенням дитячої офтальмології Центру «Ваш зір» у Чернівцях. Понад 35 років працює з маленькими пацієнтами — від немовлят до підлітків.",
      "Проводить діагностику зору у дітей раннього віку, веде консервативне та апаратне лікування короткозорості, амбліопії, косоокості. Формує індивідуальні програми лікування з урахуванням віку дитини, стадії захворювання та навантаження на очі.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Діагностика зору у дітей", desc: "Обстеження з раннього віку, включно з немовлятами, за адаптованими методиками." },
        { title: "Лікування короткозорості (міопії)", desc: "Контроль прогресування, підбір окулярів, апаратне лікування, рекомендації щодо режиму." },
        { title: "Лікування амбліопії", desc: "«Ліниве око» — комплекс апаратних та тренувальних методик для стимуляції зору." },
        { title: "Косоокість", desc: "Консервативне лікування, підбір окулярів, за потреби — направлення на хірургічне лікування." },
        { title: "Апаратне лікування зору", desc: "Курси на спеціальному обладнанні для тренування акомодації, бінокулярного зору, гостроти зору." },
        { title: "Підбір окулярів для дітей", desc: "Корекція короткозорості, далекозорості, астигматизму з урахуванням віку та активності дитини." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 35 років у дитячій офтальмології",
        "Лікар вищої кваліфікаційної категорії",
        "Завідувачка відділенням дитячої офтальмології",
        "Досвід роботи з дітьми з раннього віку",
        "Комплексні програми апаратного лікування",
        "Індивідуальний підхід до кожної дитини",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються батьки",
      items: [
        "Дитина мружиться або нахиляє голову, щоб бачити",
        "Погіршення зору, скарги на «розмите» зображення",
        "Косоокість або асиметрія очей",
        "Діагноз «амбліопія», «астигматизм», «далекозорість»",
        "Контроль зору перед школою та під час навчання",
        "Прогресування короткозорості",
        "Обстеження за направленням педіатра або перед садочком/школою",
      ],
    },
    faq: [
      { q: "З якого віку можна показати дитину офтальмологу?", a: "Огляд можливий з перших місяців життя. Планові візити рекомендовані у 6 місяців, 1 рік, перед садочком і перед школою." },
      { q: "Як проходить апаратне лікування зору для дітей?", a: "Це курс щоденних сеансів (5-10 днів) на спеціальному обладнанні, що стимулює акомодацію, бінокулярний зір і гостроту зору. Проводиться в ігровій формі." },
      { q: "Чи можна зупинити прогресування короткозорості у дитини?", a: "Так, при своєчасному виявленні. Використовуються спеціальні окуляри або лінзи, апаратне лікування, режим зорових навантажень та рекомендації щодо способу життя." },
      { q: "Що таке «ліниве око» і як його лікують?", a: "Якщо у якомусь віці одне око починає бачити гірше, ніж інше, то переважне бачення виконується здоровим оком, а гірше око «розучується» бачити все більше та більше. Лікується апаратним тренуванням, оклюзією (заклеюванням) здорового ока, спеціальними окулярами." },
      { q: "Чи потрібне направлення для запису дитини?", a: "Ні, ви можете записатися на прийом напряму, без направлення від педіатра." },
    ],
  },

  lukiian: {
    slug: "lukiian",
    seoTitle: "Лукіян Андрій Іванович — офтальмолог, лікар першої категорії | Чернівці, «Ваш зір»",
    seoDescription:
      "Лукіян Андрій Іванович — лікар-офтальмолог першої категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях. 16 років досвіду в діагностиці та лікуванні захворювань зору. Запис на консультацію.",
    tagline: "Лікар-офтальмолог першої категорії",
    subtitle:
      "Лікар-офтальмолог першої категорії з 16-річним досвідом у діагностиці та лікуванні захворювань очей",
    intro: [
      "Лукіян Андрій Іванович — лікар-офтальмолог першої кваліфікаційної категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях. Понад 16 років практики в загальній офтальмології дорослих пацієнтів.",
      "Проводить консультації, діагностику зору, супровід пацієнтів до та після операцій. Веде пацієнтів при катаракті, глаукомі, вікових змінах зору, а також щоденних скаргах — від синдрому сухого ока до підбору оптимальної корекції зору.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Консультація офтальмолога", desc: "Первинний огляд, оцінка скарг, побудова плану обстеження та лікування." },
        { title: "Діагностика катаракти й глаукоми", desc: "Виявлення захворювань на ранніх стадіях, направлення на хірургію." },
        { title: "Підбір окулярів", desc: "Корекція короткозорості, далекозорості, астигматизму, пресбіопії." },
        { title: "Лікування синдрому «сухого ока»", desc: "Діагностика й терапія при печінні, різі, дискомфорті — типово при роботі за екраном." },
        { title: "Запальні захворювання очей", desc: "Лікування кон'юнктивітів, блефаритів, ячменів." },
        { title: "Післяопераційний супровід", desc: "Контрольні огляди після операцій з катаракти, глаукоми, лазерної корекції зору." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 16 років практики в офтальмології",
        "Лікар першої кваліфікаційної категорії",
        "Ведення дорослих пацієнтів усіх вікових груп",
        "Комплексний підхід — від діагностики до післяопераційного супроводу",
        "Робота у складі команди Центру «Ваш зір»",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "Погіршення зору вдалину або при читанні",
        "Втомлюваність очей, головні болі при роботі за комп'ютером",
        "Червоні очі, свербіж, відчуття піску",
        "Планова щорічна перевірка зору",
        "Контроль зору при цукровому діабеті",
        "Підбір окулярів та лінз",
        "Огляд після операції",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Лукіяна Андрія Івановича?", a: "Запис ведеться за телефонами клініки або через онлайн-форму на сайті." },
      { q: "Скільки коштує консультація?", a: "Вартість уточнюйте за телефоном — залежить від обсягу необхідного обстеження." },
      { q: "Чи потрібне направлення для запису?", a: "Ні, ви можете записатися напряму, без направлення." },
      { q: "Скільки триває первинний огляд?", a: "Від 30 хвилин до півтори години — залежно від того, чи потрібно розширяти зіницю." },
    ],
  },

  pinchuk: {
    slug: "pinchuk",
    seoTitle:
      "Пінчук Сергій Віталійович — хірург катаракти та глаукоми, к.м.н. | Чернівці, «Ваш зір»",
    seoDescription:
      "Пінчук Сергій Віталійович — завідувач відділенням катаракти та глаукоми Центру «Ваш зір» у Чернівцях. Кандидат медичних наук, лікар вищої категорії, 29 років досвіду в мікрохірургії ока.",
    tagline: "Завідувач відділенням катаракти та глаукоми",
    subtitle:
      "Кандидат медичних наук, лікар вищої категорії. 29 років досвіду в мікрохірургії катаракти та лікуванні глаукоми",
    intro: [
      "Пінчук Сергій Віталійович — кандидат медичних наук, лікар вищої категорії, завідувач відділенням катаракти та глаукоми Центру «Ваш зір». Спеціалізується на мікрохірургічному та лазерному лікуванні катаракти та глаукоми.",
      "Понад 29 років працює в хірургічній офтальмології. Проводить безшовні операції з видалення катаракти методом факоемульсифікації з імплантацією сучасних інтраокулярних лінз (ІОЛ), а також оперативне й лазерне лікування глаукоми на різних стадіях.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Факоемульсифікація катаракти", desc: "Сучасна безшовна операція з видалення катаракти через мікророзріз — амбулаторно, з коротким відновленням." },
        { title: "Імплантація ІОЛ", desc: "Підбір та імплантація моно-, торичних і мультифокальних інтраокулярних лінз." },
        { title: "Хірургічне лікування глаукоми", desc: "Операції зниження внутрішньоочного тиску — при неефективності медикаментозної терапії." },
        { title: "Лазерне лікування глаукоми", desc: "SLT, YAG-лазерна іридотомія — малоінвазивні процедури для нормалізації тиску." },
        { title: "Ведення пацієнтів з глаукомою", desc: "Довгостроковий контроль ВОТ, полів зору, стану зорового нерва." },
        { title: "Передопераційна підготовка", desc: "Комплексне обстеження, розрахунок ІОЛ, розробка плану операції." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Кандидат медичних наук",
        "Лікар вищої кваліфікаційної категорії",
        "Завідувач відділенням катаракти та глаукоми",
        "Понад 29 років у мікрохірургії ока",
        "Досвід десятків тисяч успішних операцій з катаракти",
        "Робота з сучасним мікрохірургічним обладнанням",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "Помутніння зору, «туман» перед очима",
        "Підвищена світлочутливість, ореоли навколо ламп",
        "Погіршення нічного зору",
        "Діагноз «катаракта» або «глаукома»",
        "Підвищений внутрішньоочний тиск",
        "Планова передопераційна консультація",
        "Післяопераційний контроль",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Пінчука Сергія Віталійовича?", a: "Записатися можна за телефонами клініки або через форму на сайті." },
      { q: "Скільки триває операція з катаракти?", a: "3-5 хвилин." },
      { q: "Коли можна повернутися до звичайного життя після операції з катаракти?", a: "Відновлення зору — одразу в день процедури заміни кришталика. Невелике обмеження фізичних навантажень — протягом 10-15 днів." },
      { q: "Яку ІОЛ обрати — моно, торичну чи мультифокальну?", a: "Тип ІОЛ рекомендує лікар після обстеження." },
      { q: "Чи можна вилікувати глаукому без операції?", a: "Регулярні обстеження на якісному обладнанні та закапування призначених препаратів часто дозволяють тримати внутрішньоочний тиск у нормі — без операцій." },
    ],
  },

  urazov: {
    slug: "urazov",
    seoTitle:
      "Уразов Артем Жараспайович — вітреоретинальний хірург | Чернівці, «Ваш зір»",
    seoDescription:
      "Уразов Артем Жараспайович — провідний хірург відділення вітреоретинальної та лазерної мікрохірургії ока Центру «Ваш зір» у Чернівцях. 23 роки досвіду в хірургії сітківки.",
    tagline: "Провідний хірург відділення вітреоретинальної та лазерної мікрохірургії ока",
    subtitle:
      "Провідний хірург з 23-річним досвідом у вітреоретинальній та лазерній мікрохірургії ока",
    intro: [
      "Уразов Артем Жараспайович — провідний хірург відділення вітреоретинальної та лазерної мікрохірургії ока Центру «Ваш зір». Спеціалізується на діагностиці та хірургічному лікуванні захворювань сітківки, склистого тіла та зорового нерва.",
      "Понад 23 років працює в мікрохірургії ока. Виконує складні втручання при відшаруванні сітківки, крововиливах у склисте тіло, макулярних розривах, діабетичних ускладненнях та інших патологіях заднього відрізка ока.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Хірургія відшарування сітківки", desc: "Складні операції з повернення сітківки та її фіксації сучасними методиками." },
        { title: "Вітректомія", desc: "Мікрохірургічні втручання на склистому тілі при крововиливах, тяжах, розривах та інше." },
        { title: "Лазерна коагуляція сітківки", desc: "Профілактичне й лікувальне лазерне закріплення сітківки при дистрофіях та розривах сітківки." },
        { title: "Лікування діабетичної ретинопатії", desc: "Комплексний підхід — від лазера до вітреоретинальної хірургії." },
        { title: "Хірургія макулярних розривів та мембран", desc: "Мікроінвазивні втручання при епіретинальному фіброзі та розривах макули." },
        { title: "Інтравітреальні ін'єкції", desc: "Анти-VEGF терапія при АМД, діабетичному набряку сітківки, тромбозах вен." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 23 років у мікрохірургії сітківки",
        "Провідний хірург вітреоретинального відділення",
        "Досвід десятків тисяч операцій на сітківці та склистому тілі",
        "Робота з сучасним хірургічним обладнанням світового рівня",
        "Комплексний супровід — від діагностики до реабілітації",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "«Мушки», спалахи, плаваючі помутніння перед очима",
        "Раптове зниження зору, «тінь» у полі зору",
        "Спотворення прямих ліній",
        "Діагноз «відшарування сітківки», «розрив сітківки»",
        "Ускладнення цукрового діабету на очах",
        "Крововилив у склисте тіло",
        "Направлення до хірурга сітківки",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Уразова Артема Жараспайовича?", a: "Записатися можна за телефонами клініки або через форму на сайті." },
      { q: "Які операції на сітківці виконує Артем Жараспайович?", a: "Весь перелік лазерних та мікрохірургічних операцій на сітківці." },
      { q: "Чи болюча операція на сітківці?", a: "Ні, всі втручання проводяться при місцевому знеболенні." },
      { q: "Що робити при появі «спалахів» і «мушок» перед очима?", a: "Пройти комплексну очну діагностику." },
    ],
  },

  shyroka: {
    slug: "shyroka",
    seoTitle: "Широка Ольга Іванівна — офтальмолог, лікар другої категорії | Чернівці, «Ваш зір»",
    seoDescription:
      "Широка Ольга Іванівна — лікар-офтальмолог другої категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях. 12 років досвіду в діагностиці та лікуванні захворювань очей. Запис на консультацію.",
    tagline: "Лікар-офтальмолог другої категорії",
    subtitle:
      "Лікар-офтальмолог другої категорії з 12-річним досвідом у діагностиці та лікуванні захворювань очей",
    intro: [
      "Широка Ольга Іванівна — лікар-офтальмолог другої категорії Центру мікрохірургії ока «Ваш зір» у Чернівцях. Понад 12 років працює у сфері загальної офтальмології дорослих пацієнтів.",
      "Проводить консультації, діагностику зору, супровід до й після операцій. Веде пацієнтів із катарактою, глаукомою, запальні захворювання ока, синдромом сухого ока та інше, підбирає оптимальну корекцію зору окулярами.",
    ],
    directions: {
      title: "Напрямки роботи",
      items: [
        { title: "Консультація офтальмолога", desc: "Первинний огляд, оцінка скарг, побудова плану обстеження." },
        { title: "Діагностика катаракти й глаукоми", desc: "Раннє виявлення захворювань, направлення на хірургічне лікування за потреби." },
        { title: "Підбір окулярів", desc: "Корекція короткозорості, далекозорості, астигматизму, пресбіопії." },
        { title: "Лікування синдрому «сухого ока»", desc: "Терапія при печінні, різі, дискомфорті — часто при роботі за комп'ютером." },
        { title: "Запальні захворювання очей", desc: "Лікування кон'юнктивітів, блефаритів, ячменів." },
        { title: "Післяопераційний супровід", desc: "Контрольні огляди після операцій з катаракти, глаукоми, лазерних процедур." },
      ],
    },
    expertise: {
      title: "Досвід та кваліфікація",
      items: [
        "Понад 12 років практики в офтальмології",
        "Лікар другої кваліфікаційної категорії",
        "Ведення дорослих пацієнтів",
        "Комплексний підхід до діагностики й лікування",
        "Робота у складі команди Центру «Ваш зір»",
      ],
    },
    forWhom: {
      title: "З якими скаргами звертаються",
      items: [
        "Погіршення зору вдалину або при читанні",
        "Втомлюваність очей при роботі за комп'ютером",
        "Червоні очі, свербіж, відчуття піску",
        "Планова щорічна перевірка зору",
        "Контроль зору при діабеті",
        "Підбір окулярів та контактних лінз",
        "Огляд після операції",
      ],
    },
    faq: [
      { q: "Як записатися на прийом до Широкої Ольги Іванівни?", a: "Запис ведеться за телефонами клініки або через онлайн-форму на сайті." },
      { q: "Чи потрібне направлення для запису?", a: "Ні." },
      { q: "Скільки триває первинний огляд?", a: "Від 30 хвилин до півтори години — залежно від того, чи потрібно розширяти зіницю." },
    ],
  },
};

export const getDoctorPage = (slug) => DOCTOR_PAGES[slug] || null;
